<mat-card appearance="outlined" *ngFor="let company of companyFormArray.controls; index as i">
  <mat-card-header>
    <mat-card-title>Company details</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <mat-card [formGroup]="company">
      <mat-card-header>
        <mat-card-title>Company {{i + 1}} <small *ngIf="company?.value && company?.value?.trusteeOf >= 0 && trustList?.value && trustList?.value[company?.value?.trusteeOf]">[Trustee of {{trustList?.value[company?.value?.trusteeOf]?.trustName || trustList?.value[company?.value?.trusteeOf]?.trustType || 'Trust ' + (company?.value?.trusteeOf + 1) | uppercase }}]</small></mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div class="row mb-4" *ngIf="company?.value && company?.value?.trusteeOf >= 0 && trustList?.value[company?.value?.trusteeOf]?.trustType === 'security-trust'">
          <div class="col-7">
            <h6 class="text-danger">For TBA Company Name field please enter details using the following pattern: <strong><i>Surname Initials TBA Property Company P/L.</i></strong> Surname
              and initials will be from the contact details you enter below.</h6>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <mat-form-field appearance="outline">
              <mat-label>Company name</mat-label>
              <input matInput placeholder="Company name" formControlName="companyName">
              <mat-error>
                <app-validation-partial
                  [formGroup]="company"
                  [fieldName]="'companyName'"
                ></app-validation-partial>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-4">
            <mat-form-field appearance="outline">
              <mat-label>ACN</mat-label>
              <input matInput placeholder="ACN" formControlName="companyACN">
              <mat-error>
                <app-validation-partial
                  [formGroup]="company"
                  [fieldName]="'companyACN'"
                ></app-validation-partial>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-sm-3">
            <mat-form-field appearance="outline">
              <mat-label>Industry</mat-label>
              <mat-select placeholder="Industry" formControlName="industryType">
                <mat-option *ngFor="let type of industryTypes" [value]="type.id">
                  {{type.text}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <mat-card-title>Contact details</mat-card-title>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-3">
            <mat-form-field appearance="outline">
              <mat-label>Contact name</mat-label>
              <input matInput placeholder="Contact name" formControlName="companyContactName">
              <mat-error>
                <app-validation-partial
                  [formGroup]="company"
                  [fieldName]="'companyContactName'"
                ></app-validation-partial>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-3">
            <mat-form-field appearance="outline">
              <mat-label>Position</mat-label>
              <input matInput placeholder="Position" formControlName="companyContactPosition">
              <mat-error>
                <app-validation-partial
                  [formGroup]="company"
                  [fieldName]="'companyContactPosition'"
                ></app-validation-partial>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-3">
            <fmc-sensis-mobile
              [parentFormGroup]="company"
              [controlName]="'companyContactMobile'"
              [placeholderText]="'Phone'"
            ></fmc-sensis-mobile>
          </div>
          <div class="col-sm-3">
            <fmc-sensis-email
              [parentFormGroup]="company"
              [controlName]="'companyContactEmail'"
              [placeholderText]="'Email'"
            ></fmc-sensis-email>
          </div>

          <div [ngClass]="{'hide-block':selectedContacts?.indexOf('company-' + i) >= 0}">
            <div class="col-sm-12" *ngFor="let contact of contactList">
              <ng-container *ngIf="contact?.contactName && contact?.identity !== 'company-' + i && !contact.isDisabled">
                <mat-checkbox (change)="setContact($event, company, contact, i)" [checked]="company.value?.contactSelected === contact?.identity">
                  Same contact as <span class="text-capitalize">{{ contact?.companyTrustName }}</span>
                </mat-checkbox>
              </ng-container>
            </div>
          </div>
        </div>

        <mat-card>
          <mat-card-content>
            <div class="row">
              <div class="col-sm-12">
                <mat-card-title>Address details</mat-card-title>
              </div>
              <div class="col-sm-8">
                <app-address-suggestions
                  [formGroup]="company"
                  [control]="'tradingAddress'"
                ></app-address-suggestions>
                <fmc-address-search
                  [mode]="'external'"
                  [parentFormGroup]="company"
                  [controlName]="'tradingAddress'"
                  [placeholderText]="'Trading address'"
                  [toggleResetFormValues]="false"
                ></fmc-address-search>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8" *ngIf="!company.value.postalAddressAsTrading">
                <fmc-address-search
                  [mode]="'external'"
                  [parentFormGroup]="company"
                  [controlName]="'postalAddress'"
                  [placeholderText]="'Postal address'"
                  [toggleResetFormValues]="false"
                ></fmc-address-search>
              </div>
              <div class="col-sm-12">
                <mat-checkbox formControlName="postalAddressAsTrading" (change)="addressAsAbove(i, 'postalAddress', company.value)">
                  Postal address same as trading
                </mat-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8" *ngIf="!company.value.postSettlementAddressAsTrading">
                <fmc-address-search
                  [mode]="'external'"
                  [parentFormGroup]="company"
                  [controlName]="'postSettlementAddress'"
                  [placeholderText]="'Address after settlement'"
                  [toggleResetFormValues]="false"
                ></fmc-address-search>
              </div>
              <div class="col-sm-12">
                <mat-checkbox formControlName="postSettlementAddressAsTrading" (change)="addressAsAbove(i, 'postSettlementAddress', company.value)">
                  Address after settlement same as trading
                </mat-checkbox>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
